import React from 'react';
import PropTypes from 'prop-types';

const NotificationPanel: React.FC<Props> = () => {
  return <h6>Notifications </h6>;
};

const propTypes = {};

type Props = PropTypes.InferProps<typeof propTypes>;

NotificationPanel.propTypes = propTypes;

NotificationPanel.defaultProps = {};

export default NotificationPanel;
